import type { UserData } from '~/types/userData';
import type { ApiErrorType } from '~/types/api';
import axiosInstance from '~/api/index';
import { GET_USER_DATA } from '~/api/apiUrlsV2';

export const getUserData = async (
  token: string | null,
): Promise<{ user: UserData | null; error: ApiErrorType | null }> => {
  const response = await axiosInstance
    .get<{ object: UserData | null; error: ApiErrorType | null }>(GET_USER_DATA, {
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    })
    .catch((error) => {
      return {
        data: {
          object: null,
          error: { message: error.response.data.error.message },
        },
      };
    });

  const { object, error } = response.data;

  return {
    user: object,
    error: error,
  };
};
